module.exports = __webpack_public_path__ + "img/modelo-cantina-club-bg.f6fabe5e.jpg";